// extracted by mini-css-extract-plugin
export default {"btnRegister":"getCode_btnRegister__bL6PL"};